import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function enable2FactorAuthentication(code) {
  return dispatchCommand("Enable2FactorAuthentication", {
    code: code
  });
}
